<div class="parent-container"
  [@fadeInOutHidden]='!disabled'>
  <div class="main-form-row">
    <label for="select-container"
      class="one-form-question">
      {{questionText()}}
    </label>
    <form [formGroup]="dateForm">
      <div class="select-date-container">
        <select class="one-dropdown"
          [ngClass]="{'data-hj-suppress': addHotJarSuppressionTag()}"
          (change)="onDayChange($event)"
          (blur)="onSelectBlur()"
          [id]="getIdText('month')"
          aria-label="Date of birth month"
          formControlName="month">
          <option value="null"
            disabled
          hidden>MM</option>
          @for (option of optionsList()?.month; track option) {
            <option
              [ngValue]="option.code">{{option.value}}
            </option>
          }
        </select>
        <select class="one-dropdown"
          [ngClass]="{'data-hj-suppress': addHotJarSuppressionTag()}"
          (change)="onDayChange($event)"
          (blur)="onSelectBlur()"
          [id]="getIdText('year')"
          aria-label="Date of birth year"
          formControlName="year">
          <option value="null"
            disabled
          hidden>YYYY</option>
          @for (option of optionsList()?.futureYears; track option) {
            <option
              [ngValue]="option.code">{{option.value}}
            </option>
          }
        </select>
      </div>
    </form>

    <div class="col-md-1 offset-lg-2 text-right">
      @if (toolTipNames) {
        <app-tooltip
          [tooltipNames]='toolTipNames'>
        </app-tooltip>
      }
    </div>
  </div>
  @if (shouldShowError()) {
    <div class="error-container-inline" [@fadeInOut]>
      <div class="error-msg-icon mt-2 d-md-inline"></div>
      <p class="error-text">
        {{getErrorMessage()}}
      </p>
    </div>
  }
</div>